import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3de6e862"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-data-section" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Information needed"),
  /*#__PURE__*/_createTextVNode(": N/A")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topLevelFieldOrder, (field) => {
      return (_openBlock(), _createElementBlock("div", {
        key: field.fieldId,
        class: "js-top-level-field"
      }, [
        _createElementVNode("strong", null, _toDisplayString(field.fieldLabel), 1),
        _hoisted_2,
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(field.fieldValue), 1)
      ]))
    }), 128)),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formFieldOrder, (field) => {
        return (_openBlock(), _createElementBlock("li", {
          key: field.fieldId,
          class: "js-form-field"
        }, [
          _createElementVNode("strong", null, _toDisplayString(field.fieldLabel), 1),
          _hoisted_4,
          _hoisted_5,
          _createTextVNode(_toDisplayString(field.fieldValue), 1)
        ]))
      }), 128))
    ]),
    _hoisted_6
  ]))
}